import React, { Component } from 'react';

class FilterItem extends Component
{
    handleOnClick = (filter) =>
    {
        this.props.selectFilter(filter);
    };

    render = () =>
    {
        let className = 'filter-item';
        let style     = {border: 'none'};

        if (true === this.props.selected)
        {
            className += ' selected';
            style      = {
                borderBottomColor: this.props.theme.accentTwo,
                backgroundColor  : this.props.theme.accent
            };
        }
        return (
            <li
                className="tap-event"
                onTouchTap={ this.handleOnClick.bind(this, this.props.filterKey) }>
                    <span className={ className } style={ { ...style } }>
                        { this.props.filter.name }
                    </span>
            </li>);
    }

}

export default FilterItem;


// WEBPACK FOOTER //
// ./src/components/Filters/FilterItem.js